import { ref, update, get, set } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetAuthUserDataInFirebase from "./GetAgencyMemberDataInFirebase";

const UpdateAuthUserDataInFirebase = async (
    state,
    dispatch,
    authUserId,
    businessIds,
    userId,
    providerId
) => {
    const USERID = userId ? userId : state?.USERID;

    console.log("userid", USERID);

    if (!USERID || !authUserId) return null;

    try {

        const sharedWithRef = ref(
            database,
            `invoiceGenerator/users/${USERID}/sharedWith/${authUserId}`
        );

        // const userRef = ref(
        //     database,
        //     `invoiceGenerator/sharedWithUsers/${authUserId}`
        // );

        /* -------- UPDATE ADMIN -> MEMBER ACCESS -------- */

        await update(sharedWithRef, {
            updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            company: businessIds,
            updatedAt: Date.now().toString(),
            providerId: providerId || "password"
        });

        /* -------- ENSURE MEMBER -> ADMIN MAPPING -------- */

        // const snapshot = await get(userRef);

        // let ownerIds = [];

        // if (snapshot.exists()) {
        //     ownerIds = snapshot.val().ownerIds || [];
        // }

        // if (!ownerIds.includes(OWNER_ID)) {
        //     ownerIds.push(OWNER_ID);
        // }

        // await set(userRef, { ownerIds });

        // await GetAuthUserDataInFirebase(state, dispatch, USERID);

        return {
            success: true,
            message: "User businesses updated successfully!"
        };

    } catch (error) {

        console.error("Firebase Error:", error);

        return {
            success: false,
            message: error.message || "Failed to update user data"
        };

    }
};

export default UpdateAuthUserDataInFirebase;